export default "__VITE_ASSET__chea1FLR__"